var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { PureComponent } from "react";
import Icon, { IconTypes } from "@irati/ui/src/Icon";
import Button from "@irati/ui/src/Button";
import { FormattedMessage } from "@irati/utils/lang";
var BackLink = /** @class */ (function (_super) {
    __extends(BackLink, _super);
    function BackLink() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BackLink.prototype.render = function () {
        return (React.createElement(Button, __assign({ tertiary: true }, this.props.linkProps),
            React.createElement(Icon, { icon: IconTypes.chevronLeft, marginRight: true }),
            React.createElement(FormattedMessage, { id: "admin.teams.back.label" })));
    };
    return BackLink;
}(PureComponent));
export default BackLink;
